export const generateKeyFromName = (value: string) =>
  value.replace(/[^A-Z0-9-]/gi, "-").toLowerCase();
